import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Spinner from '../../Layouts/Spinner';
import { addDriverManagementValidation } from '../../Constant/constant';
import { addPartnerMembershipData } from '../../../redux/driverManagement/action';


const AddPartner = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const formik = useFormik({
        initialValues: {
            company_name: "",
            cr_number: "",
            status:1

        },
        validationSchema: addDriverManagementValidation,
        onSubmit: (values) => {
            handleSubmit(values);
        },
    });

    const handleSubmit = async (values) => {

        const datas = {
            ...values,

        }

        dispatch(addPartnerMembershipData(datas, navigate, setLoading))
    };




    console.log(formik.values, "values")
    return (
        <div className='mt-5 category-wrapper'>
            <h3><strong>Add Partner</strong></h3><br></br>
            <form onSubmit={formik.handleSubmit}>
                <div className='row mainrow '>
                    <div className="col-md-4 form-group">
                        <label>Partner Name</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter partner name"
                            name="company_name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.company_name}
                        />
                        {formik.touched.company_name && formik.errors.company_name ? (
                            <div className="error">{formik.errors.company_name}</div>
                        ) : null}
                    </div>

                    <div className="col-md-4 form-group">
                        <label>Cr number</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter cr number"
                            name="cr_number"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.cr_number}
                            onWheel={(e) => e.target.blur()}
                        />
                        {formik.touched.cr_number && formik.errors.cr_number ? (
                            <div className="error">{formik.errors.cr_number}</div>
                        ) : null}
                    </div>

                    <div className="col-md-4 form-group">
                        <label>Status</label>
                        <select
                            id="status"
                            name="status"
                            className='form-control'
                            onChange={(e) => formik.setFieldValue('status', Number(e.target.value))}
                            onBlur={formik.handleBlur}
                            value={formik.values.status}
                        >
                            <option value="1">Active</option>
                            <option value="2">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="col-md-12">
                    <button style={{ marginLeft: "10px", color: "white" }} className="buttons background-button mx-auto d-block" disabled={loading} type='submit'>
                        {!loading ? "Submit" : <Spinner />}</button>
                </div>
            </form>
        </div>
    )
}

export default AddPartner
